import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_336: DocMigration = {
  maxSchemaVersion: "0.0.336",
  description: "Convert boolean to enum for wrapping mode.",
  apply(json: any) {
    for (const id in json.settings) {
      const settings = json.settings[id];
      if (settings.type !== "WINDOW_WRAPPING_SETTINGS" && settings.type !== "DOOR_WRAPPING_SETTINGS") {
        continue;
      }

      json.settings[id] = {
        ...settings,
        wrappingMode: settings.hasWrapping ? "CENTER_OF_CORE" : "NONE",
      };
    }
    for (const id in json.openings) {
      const opening = json.openings[id];
      if (
        opening.type !== "WINDOW" &&
        opening.type !== "DOOR" &&
        opening.type !== "WINDOW_V2" &&
        opening.type !== "DOOR_V2"
      ) {
        continue;
      }

      if (opening.wrapping) {
        json.openings[id] = {
          ...opening,
          wrapping: {
            ...opening.wrapping,
            wrappingMode: opening.wrapping.hasWrapping ? "CENTER_OF_CORE" : "NONE",
          },
        };
        console.log("updated", json.openings[id]);
      }
    }
    return json;
  },
};

export default migration_0_0_336;
